<script lang="ts" setup>
import * as ElementIcons from '@element-plus/icons-vue'
import { getMenu } from '@/api/menu'
import { ref, onMounted, watch } from "vue"
import { useRoute } from 'vue-router'
import useWebTabsStore from '@/store/webtabs'

// 获取 Pinia Store
const tabsStore = useWebTabsStore()

// console.log('tabsStore', tabsStore);


// 存储菜单数据
const menuItems = ref<any[]>([])

// 获取路由实例
const route = useRoute()

// 设定选中菜单
const defaultActive = ref(route.path)  // **改为 ref，使其可响应式更新**
const defaultOpeneds = ref<string[]>([])
// 监听路由变化，自动更新 `defaultActive`
watch(route, () => {
  defaultActive.value = route.path
  const openKeys = getOpenKeys(route.path)
  if (openKeys.length > 0) {
    defaultOpeneds.value = openKeys
  } else{
    if (menuRef.value) {
      // 先收起所有打开的菜单（Element Plus 没有提供 closeAll，所以需要自己关）
      menuItems.value.forEach(item => {
        menuRef.value.close(item.path)
      })

      // 有需要展开的，手动 open
      openKeys.forEach(key => {
        menuRef.value.open(key)
      })
    }
  }
  console.log("路由变化",route.path)
  console.log("路由变化",defaultOpeneds.value)
})
const getOpenKeys = (path: string) => {
  const parts = path.split('/').filter(Boolean)

  if (parts.length <= 2) {
    return []  // 没有上级，不展开任何项
  }
  const openKeys: string[] = []
  for (let i = 0; i < parts.length - 1; i++) {
    openKeys.push('/' + parts.slice(0, i + 1).join('/'))
  }
  return openKeys
}
const fetchMenuData = async () => {
  try {
    const res = await getMenu()
    menuItems.value = res.data

    if (menuItems.value.length > 0) {

      // **找到与当前路由匹配的菜单项**
      const matchedItem = menuItems.value.find(item => item.path === route.path)

      if (matchedItem) {
        defaultActive.value = matchedItem.path // **更新 defaultActive**

      }
    }
  } catch (error) {
    // console.error('获取菜单失败', error)
  }
}

// 组件挂载时获取数据
onMounted(fetchMenuData)



// 根据图标名动态返回对应的图标组件
function getIconComponent(iconName: string) {
  return (ElementIcons as Record<string, any>)[iconName] || ElementIcons.Menu
}
interface MenuItem {
  path: string;
  title: string;
  icon?: string;
  children?: MenuItem[];
}
let clickLock = false; // 点击锁
// 点击添加标签操作
function handleClick(menuItem: MenuItem) {
  if (clickLock) return;
  clickLock = true;


  setTimeout(() => {
    clickLock = false; // 解锁（例如 300ms 后可以再次点击）
  }, 500);


  // 只处理叶子节点的点击事件
  if (menuItem.children && menuItem.children.length > 0) {
    return;
  }
  // 获取当前打开的标签列表
  const existingTab = tabsStore.findTabByPath(menuItem.path);

  if (existingTab) {
    return;
  }
  const title = menuItem.title || '未知菜单';

  // 添加 Web 标签
  tabsStore.addWebTab({
    name: menuItem.path,
    title: title,
    content: '',
    path: menuItem.path
  });
}

function open_menu(key:string) {
  // 在 menuItems 里查找对应的 title
  const menu = menuItems.value.find(item => item.path === key)
  const title = menu ? menu.title : '未知菜单'

  // 获取当前打开的标签列表
  const existingTab = tabsStore.findTabByPath(key);
  console.log("正在点击",menu);
  if (existingTab || menu.children.length > 0) {
    return;
  }

  console.log(key)
  // 添加 Web 标签
  tabsStore.addWebTab({
    name: key,
    title: title,
    content: '',
    path: key
  });
}
const menuRef = ref<any>(null)  // ElementPlus 没有类型定义

</script>

<template>
  <div class="menu">
    <el-menu
        router
        ref="menuRef"
        :default-active="defaultActive"
        :default-openeds="defaultOpeneds"
        class="el-menu-vertical-left"
        @open="open_menu"
    >
      <!-- 动态渲染菜单 -->
      <template v-for="menu in menuItems" :key="menu.path">
        <el-sub-menu v-if="menu.children && menu.children.length" :index="menu.path">
          <template #title>
            <el-icon>
              <component :is="getIconComponent(menu.icon)" />
            </el-icon>
            <span>{{ menu.title }}</span>
          </template>
          <template v-for="child in menu.children" :key="child.path">
            <el-sub-menu v-if="child.children && child.children.length" :index="child.path">
              <template #title><span>{{ child.title }}</span></template>
              <el-menu-item v-for="subChild in child.children" :key="subChild.path" :index="subChild.path">
                {{ subChild.title }}
              </el-menu-item>
            </el-sub-menu>
            <el-menu-item v-else :index="child.path"   @click="handleClick(child)">{{ child.title }}</el-menu-item>
          </template>
        </el-sub-menu>

<!--        没有子菜单-->
        <el-menu-item v-else :index="menu.path" @click="handleClick(menu)">
          <el-icon><component :is="getIconComponent(menu.icon)" /></el-icon>
          <span>{{ menu.title }}</span>
        </el-menu-item>
      </template>
    </el-menu>
  </div>
</template>
